import styled from "styled-components";

export default styled.div`
  width: 100vw;
  min-height: 400px;
`;
